<template lang="pug">
  .content-page
    Breadcrumbs(:breadcrumbsList="breadcrumbsList")

    .content-page__wrapper
      h1.inner-title(v-html="page.title.rendered")
      .content-page__content(v-html="page.content.rendered")
</template>

<script>
import api from '@/api/index'
import Breadcrumbs from '@/components/partials/Breadcrumbs'

export default {
  validate({ params }) {
    const pages = [
      'faq',
      'payment-security',
      'shipping',
      'return-refunds',
      'terms-conditions',
      'privacy-policy',
      'cookie-policy'
    ]

    return pages.includes(params.slug)
  },

  components: { Breadcrumbs },

  data() {
    return {
      page: {},

      breadcrumbsList: [
        {
          link: this.localePath('index'),
          name: this.$t('breadcrumbs.home')
        },
        {
          link: this.$route.path,
          name: ''
        }
      ]
    }
  },

  head() {
		let breadcrumbsMarkup = {
			"@context": "https://schema.org",
			"@type": "BreadcrumbList",
				"itemListElement": [{
					"@type": "ListItem",
					"position": 1,
					"name": this.$t('breadcrumbs.home'),
					"item": 'https://sitelle.ua' + this.localePath('index')
				},{
					"@type": "ListItem",
					"position": 2,
					"name": this.page.title.rendered,
					"item": 'https://sitelle.ua' + this.$route.path
				}]
		}

    return {
      title: this.pageTitle,
      titleTemplate: null,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaDescr
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.pageTitle
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.metaDescr
        }
			],
			script: [
				{
					type: 'application/ld+json',
					innerHTML: JSON.stringify(breadcrumbsMarkup)
				}
			]
    }
  },

  computed: {
    pageTitle() {
      return this.page.yoast_meta.yoast_wpseo_title
    },

    metaDescr() {
      return this.page.yoast_meta.yoast_wpseo_metadesc
    }
  },

  async asyncData({ store, params }) {
    const data = await api.getPage(params.slug, store.state.geoData.locale)

    return { page: data }
  },

  created() {
    this.breadcrumbsList[
      this.breadcrumbsList.length - 1
    ].name = this.page.title.rendered
  }
}
</script>

<style lang="scss">
@import '~assets/scss/helpers/vars';
@import '~assets/scss/helpers/mixins';

.content-page {
  padding: 20px 0 100px;

  @include laptop {
    padding-bottom: 80px;
  }

  @include mobile {
    padding-bottom: 65px;
  }

  @include mobile {
    padding: 25px 0 40px;
  }

  &__wrapper {
    padding-top: 20px;
    letter-spacing: -0.3px;

    @include mobile {
      padding-top: 0;
    }
  }

  &__content {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    overflow: auto;

    h2 {
      margin: 20px 0;
      font-size: 36px;
      font-weight: 500;
      line-height: 1.12;

      @include laptop {
        font-size: 32px;
      }

      @include tablet {
        font-size: 28px;
      }

      @include mobile {
        font-size: 24px;
      }
    }

    h3 {
      margin: 5px 0;
      font-size: 28px;
      font-weight: 500;
      line-height: 1.45;

      @include laptop {
        font-size: 26px;
      }

      @include tablet {
        font-size: 24px;
      }

      @include mobile {
        font-size: 20px;
      }
    }

    h4 {
      margin: 10px 0;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.2;

      @include laptop {
        font-size: 18px;
      }

      @include tablet {
        font-size: 16px;
      }
    }

    ol {
      counter-reset: list;

      li {
        position: relative;
        padding-left: 35px;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 20px;
        }

        &:before {
          content: counter(list) '.';
          counter-increment: list;
          position: absolute;
          top: 5px;
          left: 0;
          display: block;
          color: $yellowColor;
          font-size: 22px;
          font-weight: 500;
          line-height: 1;
        }
      }
    }

    ul {
      li {
        position: relative;
        padding-left: 25px;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 20px;
        }

        &:before {
          content: '';
          position: absolute;
          top: 5px;
          left: 0;
          display: block;
          width: 10px;
          height: 10px;
          background-color: #ffc200;
          border-radius: 50%;
        }
      }
    }

    table {
      border: 1px solid #ebeae8;

      th {
        padding: 20px 30px;
        text-align: center;

        &:first-child {
          text-align: left;
        }
      }

      td {
        padding: 20px 30px;
        text-align: center;

        &:first-child {
          text-align: left;
        }
      }
    }
  }
}
</style>
